module.exports = __webpack_public_path__ + "static/media/lumbering31.69e61adf.jpg";